<template>
<keep-alive include="fr-group-view"> 
        <router-view />
</keep-alive>
</template>
<script>
export default {
  name: "App",
  mounted() {
   
  },
  methods: {
    
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue